export const STORAGE_KEY = 'telify:attribution:v1';
export const TOKEN_REGEX = /^[A-Za-z0-9_-]{22}$/;
